module.exports = require('./dist/lib/hash');
